const forgotPassword = {
  forgotYourPassword: 'שכחת את הסיסמה?',
  backToLogin: 'המשך להתחברות',
  sendResetLink: 'שלח קישור לאיפוס',
  emailHint: 'כתובת האימייל שקיבלת מהמנהל שלך',
  noWorries: 'אל דאגה! אנא הזן את האימייל שלך ונשלח לך קישור לאיפוס הסיסמה.',
  PleaseEnterEmailAddress: 'אנא הזן את כתובת האימייל שלך',
  thankYou: 'תודה!',
  forgotPassword: 'שכחת סיסמה',
  successHint: 'אם האימייל שהזנת קיים במערכת שלנו\nנשלח קישור לאיפוס הסיסמה בעוד כמה שניות',
  emailAddress: 'כתובת אימייל',
  redirect: 'You will be redirected in ',
  seconds: ' seconds',
  emailRequires: 'אימייל נדרש',
  invalidEmail: 'אימייל אינו תקין',
};

export default forgotPassword;
